import { Container, Graphics } from "pixi.js";
export default class Web extends Container {
  constructor() {
    super();
  }
  addNode() {
    let p = new Graphics();
    this.addChild(p);
    return p;
  }
  clear() {
    while (this.children.length > 0) {
      let child = this.children[0];
      this.removeChild(child);
      child.clear();
      child = null;
    }
  }
}
